exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PostTitleConditions__link___fsR_u {\n\ttext-decoration: none;\n\tcolor: inherit;\n\tfont-weight: bold;\n\theight: 1.5rem;\n    display: flex;\n    align-items: center;\n}\n\n.PostTitleConditions__button___bCHYA {\n\tpadding: 0;\n\tborder-bottom: none;\n\tdisplay: inline;\n}\n\n.PostTitleConditions__buttonRoot___10yNF {\n\tpadding: 0!important;\n\tmargin: 0!important;\n\tmin-width: inherit!important;\n}\n\n.PostTitleConditions__buttonLabel___hvsyh {\n\twidth: inherit!important;\n}\n\n.PostTitleConditions__range___3MlIJ {\n\tmargin-right: 0.5rem;\n\tfont-weight: normal;\n}\n", ""]);

// exports
exports.locals = {
	"link": "PostTitleConditions__link___fsR_u",
	"button": "PostTitleConditions__button___bCHYA",
	"buttonRoot": "PostTitleConditions__buttonRoot___10yNF",
	"buttonLabel": "PostTitleConditions__buttonLabel___hvsyh",
	"range": "PostTitleConditions__range___3MlIJ"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/Item/PostTitleConditions.icss
// module id = 1309
// module chunks = 0